export { default } from './useEventListener';

export type { UseEventListener } from './types';
